import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Card, Modal, Typography } from "antd";
import Flex from "utils/Flex";
import styles from "./ConfirmUpdateModal.module.scss";

export interface ConfirmUpdateModalProps {
  visible?: boolean;
  onOk?: () => void;
  onCancel?: () => void;
}

export const ConfirmUpdateModal = ({
  visible,
  onOk,
  onCancel,
}: ConfirmUpdateModalProps): JSX.Element => {
  return (
    <Modal
      centered
      open={visible}
      title={null}
      footer={null}
      onCancel={onCancel}
      closeIcon={<></>}
      className={styles.modal}
    >
      <Card className={styles.card}>
        <Flex.Col>
          <Typography.Title
            level={3}
            style={{ textAlign: "center", userSelect: "none" }}
          >
            Ви впевнені що хочете оновити дані ?
          </Typography.Title>
          <Flex.Row gap={18}>
            <Flex.Item flex={1}>
              <Button
                style={{ borderRadius: 4 }}
                type="primary"
                icon={<CheckOutlined />}
                onClick={onOk}
                block
              >
                Так
              </Button>
            </Flex.Item>
            <Flex.Item flex={1}>
              <Button
                style={{ borderRadius: 4 }}
                type="primary"
                icon={<CloseOutlined />}
                onClick={onCancel}
                block
                danger
              >
                Ні
              </Button>
            </Flex.Item>
          </Flex.Row>
        </Flex.Col>
      </Card>
    </Modal>
  );
};
